import React from "react";
import View from "components/studio/rightnav/RightNav.view";


function RightNav({
  flow,
  activeSection,
  isCollapsed,
  onClickCollapse
}) {

  return (
    <View
      flow={flow}
      activeSection={activeSection}
      isCollapsed={isCollapsed}
      onClickCollapse={onClickCollapse}
    />
  );
}


export default RightNav;